// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FnjKmutMoMSzJSbMkSNg{width:100%}.ZgYD0cujTWtb1h5k8XpE{display:flex;justify-content:flex-start}.X5kR5YzXNAsgh77T90RA{display:flex;gap:8px;color:var(--content-primary-tertiary)}`, "",{"version":3,"sources":["webpack://./src/widgets/SendFrom/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CAGF,sBACE,YAAA,CACA,0BAAA,CAGF,sBACE,YAAA,CACA,OAAA,CACA,qCAAA","sourcesContent":[".dropdown {\n  width: 100%;\n}\n\n.trigger {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.loading {\n  display: flex;\n  gap: 8px;\n  color: var(--content-primary-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `FnjKmutMoMSzJSbMkSNg`,
	"trigger": `ZgYD0cujTWtb1h5k8XpE`,
	"loading": `X5kR5YzXNAsgh77T90RA`
};
export default ___CSS_LOADER_EXPORT___;
